import { Frequency } from "@components/forms/ClassForm/SelectFrequency"


// Maps to show how many Pseudo-classes should be created based on the frequency
export const ClassFrequencyMap = {
    [Frequency.DAILY]: 30,
    [Frequency.WEEKLY]: 5,
    [Frequency.MONTHLY]: 1
}